import styled from 'styled-components';
import { MOBILE_BREAKPOINT, SELECTORS, TABLET_BREAKPOINT } from '../../constants';

export const InformationCardSection = styled.section`
    ${SELECTORS} & {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 100px;
  }
`;


export const InformationCardItemContainer = styled.div`
    ${SELECTORS} & {
      width: 48%;
      background: #3c4145;
      border-radius: 20px;
      padding: 40px;
      margin: 1%;
    }
    @media (max-width: ${MOBILE_BREAKPOINT}) { 
          ${SELECTORS} & {
            width: 100%;
            margin: 7px 1%;
            padding: 20px;
          }
    }
`;

export const InformationCardSvgAndTitle = styled.div`
    ${SELECTORS} & {
      display: flex;
      flex-direction: row;
      justify-content: left;
      align-items: center;
      margin-bottom: 20px;
      svg{
        margin-right: 20px;
        min-width: 60px;
        display: block;
        height: auto;
      }
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            svg{
              max-width: 50px;
            }
        }
   }
   @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
            display: block;
            margin-bottom: 10px;
            svg{
              margin-bottom: 10px;
            }
        }
   }
`;


export const InformationCardItemTitle = styled.h3`
    ${SELECTORS} & {
      width : fit-content;
      padding: 0;
    }
`;

export const InformationCardItemDescription = styled.p`
    ${SELECTORS} & {
      width : auto;
      
    }
`;
